const initialState = {
  closeModal: true,
  yuzniAniqlashVisibility: true
}
const RobberyModalState = (state = initialState, action) => {
  switch (action.type) {
    case "CLOSE_ROBBERY_MODAL":
      return { ...state, closeModal: action.val }
    case "YUZNI_ANIQLASH_HIDDEN_MODAL":
      return { ...state, yuzniAniqlashVisibility: action.val }
    default:
      return state
  }
}

export default RobberyModalState
